import { useAppSelector } from '../store/hooks'
import { selectAccountId } from '../store/auth/authSlice'
import { useGetAccountQuery } from '../store/accountUserSettings/accountUserSettings'

interface UseIsFeatureAdvertisementEnabledProps {
  bypass?: boolean
}

export const useIsFeatureAdvertisementEnabled = ({ bypass }: UseIsFeatureAdvertisementEnabledProps = {}) => {
  const accountId = useAppSelector(selectAccountId)
  const { data: accountResponse, isFetching, isLoading } = useGetAccountQuery({ accountId })
  const effectiveConfig = accountResponse?.data?.effectiveConfig

  const isEnabled = !!bypass || !!effectiveConfig?.billing.featureAdvertisementEnabled

  return { isEnabled, isFetching, isLoading }
}
